import { startOfDay, addDays, addMonths, format, isBefore, parseISO, isAfter } from 'date-fns';

export const CALENDAR_DAYS_COUNT = 7;
export const BOOKING_CALENDAR_MONTHS_AHEAD = 2;

export const getTodayStart = () => startOfDay(new Date());

/** First visible calendar day — never before today. */
export const clampCalendarStart = (date) => {
  const start = startOfDay(date instanceof Date ? date : parseISO(date));
  const today = getTodayStart();
  return isBefore(start, today) ? today : start;
};

export const getCalendarDates = (startDate) => {
  const start = clampCalendarStart(startDate);
  return Array.from({ length: CALENDAR_DAYS_COUNT }, (_, i) =>
    format(addDays(start, i), 'yyyy-MM-dd')
  );
};

/** Booking view: today through end of month two months ahead (inclusive). */
export const getBookingCalendarRange = () => {
  const start = getTodayStart();
  const end = startOfDay(addMonths(start, BOOKING_CALENDAR_MONTHS_AHEAD));
  return {
    startDate: format(start, 'yyyy-MM-dd'),
    endDate: format(end, 'yyyy-MM-dd')
  };
};

export const getBookingCalendarDates = () => {
  const { startDate, endDate } = getBookingCalendarRange();
  const dates = [];
  let current = parseISO(startDate);
  const end = parseISO(endDate);
  while (!isAfter(current, end)) {
    dates.push(format(current, 'yyyy-MM-dd'));
    current = addDays(current, 1);
  }
  return dates;
};

export const isEarliestCalendarWindow = (startDate) =>
  clampCalendarStart(startDate).getTime() === getTodayStart().getTime();

export const isWeekendDate = (dateStr) => {
  const day = parseISO(dateStr).getDay();
  return day === 0 || day === 6;
};

/** Nominative weekday names for calendar headers (not accusative -į from date-fns EEEE). */
const LT_WEEKDAY_NOMINATIVE_WIDE = [
  'Sekmadienis',
  'Pirmadienis',
  'Antradienis',
  'Trečiadienis',
  'Ketvirtadienis',
  'Penktadienis',
  'Šeštadienis'
];

const LT_WEEKDAY_NOMINATIVE_SHORT = ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'];

export const formatCalendarWeekdayLt = (dateStr, { short = false } = {}) => {
  const dayIndex = parseISO(dateStr).getDay();
  return short ? LT_WEEKDAY_NOMINATIVE_SHORT[dayIndex] : LT_WEEKDAY_NOMINATIVE_WIDE[dayIndex];
};

export const WEEKDAY_UNAVAILABLE_COLOR = '#e0e0e0';
export const WEEKEND_UNAVAILABLE_COLOR = '#c4c4c4';

export const getUnavailableSlotColor = (dateStr) =>
  isWeekendDate(dateStr) ? WEEKEND_UNAVAILABLE_COLOR : WEEKDAY_UNAVAILABLE_COLOR;

export const getCalendarStartFromUrl = (weekParam) => {
  if (weekParam) {
    try {
      return clampCalendarStart(parseISO(weekParam));
    } catch {
      // fall through
    }
  }
  return getTodayStart();
};
